import { render, staticRenderFns } from "./application_announcement_service_appendix1.vue?vue&type=template&id=fda83c88&scoped=true"
import script from "./application_announcement_service_appendix1.vue?vue&type=script&lang=js"
export * from "./application_announcement_service_appendix1.vue?vue&type=script&lang=js"
import style0 from "./application_announcement_service_appendix1.vue?vue&type=style&index=0&id=fda83c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda83c88",
  null
  
)

export default component.exports